import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { BORDER, INK, TEAL } from "../styles";
import type { NavMenuProps } from "../types";

export default function NavMenu({ label, items, openMenu, setOpenMenu }: NavMenuProps) {
  const isOpen = openMenu === label;
  return (
    <div
      onMouseEnter={() => setOpenMenu(label)}
      onMouseLeave={() => setOpenMenu(null)}
      style={{ position: "relative" }}
    >
      <button
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 4,
          color: INK,
          fontWeight: 500,
          fontSize: 14,
          fontFamily: "inherit",
          padding: "6px 8px",
          borderBottom: isOpen ? "2px solid " + TEAL : "2px solid transparent",
          transition: "border-color 0.15s",
        }}
      >
        {label}
        {isOpen ? <ChevronUp size={14} strokeWidth={2} /> : <ChevronDown size={14} strokeWidth={2} />}
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            background: "#fff",
            border: "1px solid " + BORDER,
            borderRadius: 10,
            minWidth: 220,
            padding: "8px 0",
            boxShadow: "0 10px 30px -10px rgba(0,0,0,0.18)",
            zIndex: 50,
          }}
        >
          {items.map((it, i) => (
            <a
              key={i}
              href={it.href}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#F1F5F5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
              style={{
                display: "block",
                padding: "10px 16px",
                color: INK,
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              {it.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}